export default class ResponsiveWrapper {

	static _mapClasses( $from, $to, classMap = {} ) {
		classMap = { ...ResponsiveWrapper.globalClassMap, ...classMap };
		Object.keys( classMap ).forEach( function( key ) {
			if ( $from.hasClass( key ) ) {
				$to.addClass( classMap[key] );
			}
		} );
	}

	static wrap( selector, classMap = {} ) {
		jQuery( '.entry-content' ).children( selector ).each(
			function() {
				let $this = jQuery( this );
				if ( $this.parent().hasClass( ResponsiveWrapper.wrapperClass ) ) {
					return;
				}
				let $wrapper = jQuery( '<div></div>' ).addClass( ResponsiveWrapper.wrapperClass );
				ResponsiveWrapper._mapClasses( $this, $wrapper, classMap );
				$this.wrap( $wrapper );
			}
		);
	}

	static wrapDefaultSelectors() {
		Object.keys( ResponsiveWrapper.defaultSelectors ).forEach( function( selector ) {
			let selectorSettings = ResponsiveWrapper.defaultSelectors[selector];
			if ( ! selectorSettings.hasOwnProperty( 'classMap' ) ) {
				selectorSettings.classMap = {};
			}
			ResponsiveWrapper.wrap( selector, selectorSettings.classMap );
		} );
	}

	constructor() {
		ResponsiveWrapper.wrapDefaultSelectors();
	}
}

ResponsiveWrapper.wrapperClass = "theme-responsive-wrapper";

ResponsiveWrapper.globalClassMap = {
	'alignwide': "alignwide",
	'alignfull': "alignfull",
};

ResponsiveWrapper.defaultSelectors = {
	'.wp-block-table': {
		'classMap': {
			'wp-block-table': "wp-block-table-responsive",
		},
	},
};